import { bootstrapFrontEnd } from "@/main/bootstrap/bootstrapFrontEnd";

let initialized = false;

export function initializeFrontEnd() {
    if (initialized) {
        return;
    }

    bootstrapFrontEnd();
    initialized = true;
}

if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", () => {
        initializeFrontEnd();
    });
} else {
    initializeFrontEnd();
}
